/* eslint-disable jsx-a11y/alt-text */
import { useState } from 'react'
import googleDrive from './assets/googleDrive.svg'
import dropBox from './assets/dropBox.svg'
import Upload from './assets/Upload.svg'
import MyDropzone from './dropBox/MyDropzone'
import { useUsersContext } from '../../../context/usersContext'
import filesubnmitted from './assets/folder-access.ico'
import DropboxChooser from './ThirdParty/DropboxChooser'
import GoogleDrivePickers from './ThirdParty/GoogleDrivePickers'
import { useAppServices } from '../../../hook/services'
import { useUserInfo } from '../../../context/user'
import env from '../../../config/env'
import axios from 'axios'
import YoureAllSet from './YoureAllSet'
import { useLocation, useNavigate } from 'react-router-dom'
import { Toast } from '../../../components/Toast/Toast'
import { set } from 'date-fns'
import { CircularProgress } from '@mui/material'

const ConfigureYourAIUpload = ({ setBusinessType, setSuccess, HandleEveryStep }) => {
    const BASE_URL = `${env.API_URL}/v1`;
    const [alertModel, setAlertModel] = useState(false);
    const [loader, setLoader] = useState(false);
    const [successModel, setSuccessModel] = useState(false);
    const [spinnerLoading, setSpinnerLoading] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const Service = useAppServices();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const [userInfo, , ,                // user, Update, clear
        setUserActiveLocation,
        userActiveLocation,
        saveActiveLocation,  // ⬅️ we’ll reuse the existing helper
    ] = useUserInfo();
    const { contextUploadFileOnboarding, } = useUsersContext();
    const [toastVisible, setToastVisible] = useState(false);
    const [toastType, setToastType] = useState('error');
    const [toastMessage, setToastMessage] = useState('');
    const [toastSubMessage, setToastSubMessage] = useState('');
    const [isAnimationCompleted, setIsAnimationCompleted] = useState(false);

    const location = useLocation();
    const { accountDataLocation } = location.state || {};
    const handleOnboardingError = (err) => {
        console.error("Onboarding upload failed:", err);

        const apiMsg = err?.response?.data?.error?.err ||
            err?.response?.data?.error?.error ||
            "Unknown error";


        // customise common cases from your backend
        if (apiMsg === "Bad request, no abstract generated") {
            setToastType('error');
            setToastMessage('The uploaded doc does not contain sufficient information.');
            setToastSubMessage('Please upload a doc with more substantial written content.');
            setToastVisible(true);
        } else {
            setToastType('error');
            setToastMessage('Upload failed. Please try again.');
            setToastSubMessage('Please try again.');
            setToastVisible(true);
        }

        setDisabled(false);
        setLoading(false);
    };

    const gettingfilefromdropzone = async (files) => {
        setLoading(true);
        setIsAnimationCompleted(true);

        const responseOld = await contextUploadFileOnboarding(
            files,
            "",
            setSpinnerLoading
        );

        if (!responseOld) return setLoading(false);

        try {
            const file_ids = responseOld.data.data.map((obj) => obj.name);

            if (file_ids.length > 0) {
                setAlertModel(false);
                setDisabled(true);
            }

            /* 🟢  try‑wrapped onboarding call */
            await axios.post(`${BASE_URL}/users/onboarding`, {
                file_ids,
                profileId: accountDataLocation ? accountDataLocation : userActiveLocation.id,
                username: userActiveLocation.business_name || userActiveLocation?.first_name,
            });

            /* optional: update account */
            const { response } = await Service.accounts.update({
                payload: {
                    onboarding: {
                        ...userActiveLocation.onboarding,
                        file_ids,
                        email: userInfo.email,
                        verified: userInfo?.verified ?? true,
                    },
                    _id: accountDataLocation ? accountDataLocation : userActiveLocation.id,
                },
                toaster: true,
            });

            if (response) {
                HandleEveryStep(5);
                await saveActiveLocation(response.data)
                setUserActiveLocation(response.data);
            }
            setLoading(false);

            setToastMessage(() => '')
        } catch (err) {
            handleOnboardingError(err);
        }
    };

    const filesFromThirdParty = async (files) => {
        const uploadRes = await contextUploadFileOnboarding(
            files,
            "",
            setSpinnerLoading
        );
        if (!uploadRes?.data?.success) return;

        const file_ids = uploadRes.data.data.map((obj) => obj.name);
        setLoading(true);
        setIsAnimationCompleted(true);


        try {
            /* 🟢 onboarding API wrapped in try/catch */
            await axios.post(`${BASE_URL}/users/onboarding`, {
                file_ids,
                profileId: accountDataLocation ? accountDataLocation : userActiveLocation.id,
                username: userActiveLocation.business_name,
            });

            const { response } = await Service.accounts.update({
                payload: {
                    onboarding: {
                        file_ids,
                        email: userInfo.email,
                        verified: userInfo?.verified ?? true,
                        ...userActiveLocation.onboarding
                    },
                    _id: accountDataLocation ? accountDataLocation : userActiveLocation.id,
                },
                toaster: true,
            });

            if (response?.success) {
                const updatedLocation = {
                    ...userActiveLocation,
                    onboarding: {
                        email: userInfo.email,
                        verified: userInfo?.verified ?? true,
                        ...userActiveLocation.onboarding,
                        file_ids: file_ids,
                    },
                };
                await saveActiveLocation(response.data)
                setUserActiveLocation(updatedLocation);
                setToastMessage(null);
                setLoading(false);
            }
        } catch (err) {
            handleOnboardingError(err);
            setLoading(false);
        }
    };

    if (isAnimationCompleted) {
        return (
            <YoureAllSet
                success={loading}
                onComplete={async () => {
                    if (!toastMessage && !loading) {
                        // Check if payment is required before navigating
                        if (userActiveLocation?.type === "premium" && !userActiveLocation?.subscription_id) {
                            try {
                                const resp = await Service.saas.fetchPlanById({ plan: userActiveLocation.plan_id });
                                if (!resp.response?.data?.is_free_saas) {
                                    navigate("/auth/add-payment");
                                    return;
                                }
                            } catch (e) {
                                console.error("Error checking plan:", e);
                            }
                        }
                        navigate("/app/chat")
                    } else if (toastMessage || loading) {
                        // If there's an error or still loading, reset to show the form again
                        setIsAnimationCompleted(false)
                        if (loading) {
                            setToastType("error");
                            setToastMessage("Request Timeout!");
                            setToastSubMessage("Unexpected error occurred");
                            setToastVisible(true);
                            setLoading(false)
                        }
                    }
                }}
            />
        );
    }


    return (
        <div>
            {spinnerLoading ? <div className='h-screen w-full flex items-center justify-center'><CircularProgress size={30} /></div> : <div className="container-main !w-[430px]" style={{ background: "white" }}>
                <div className="container" style={{ background: "white" }}>
                    <div className="">
                        <div className="text-center">
                            <h1 className="text-[30px] font-medium">Configure Your AI</h1>
                            <p className={`mt-4 ${toastMessage ? "text-[#C00F0C]" : "text-black"}`}>
                                {toastMessage && toastMessage + " " + toastSubMessage}
                            </p>
                        </div>

                        <div className='mt-10 items-center text-center'>
                            <div className="mt-10 items-center text-center">
                                <div
                                    onClick={() => {
                                        console.log("Google Drive clicked");
                                    }}
                                    className="relative border shadow mb-[10px] cursor-pointer !border-[#D9D9D9] h-[45px] flex items-center justify-center rounded-md"
                                >
                                    <img src={googleDrive} alt={'Connect to Google Drive'} className="absolute left-4 top-[14px]" />
                                    <GoogleDrivePickers disabled={disabled} files_send_to_parent={filesFromThirdParty} setSpinnerLoading={setSpinnerLoading} />
                                </div>

                                <div
                                    onClick={() => {
                                        console.log("Google Drive clicked");
                                    }}
                                    className="relative border shadow mb-[10px] cursor-pointer !border-[#D9D9D9] h-[45px] flex items-center justify-center rounded-md"
                                >
                                    <img src={dropBox} alt={'Connect to Dropbox'} className="absolute left-4 top-[14px]" />
                                    <DropboxChooser disabled={disabled} files_send_to_parent={filesFromThirdParty} setSpinnerLoading={setSpinnerLoading} />
                                </div>

                                {/* <div
                                    onClick={() => {
                                        console.log("Google Drive clicked");
                                    }}
                                    className="relative border shadow mb-[10px] cursor-pointer !border-[#D9D9D9] h-[45px] flex items-center justify-center rounded-md"
                                >
                                    <img src={cloud} alt={'Connect to OneDrive'} className="absolute left-4 top-[14px]" />
                                    <span className="text-[12px]">Upload from Computer</span>
                                </div> */}

                                <div
                                    onClick={() => {
                                        setAlertModel(true);
                                    }}
                                    className="relative border shadow mb-[10px] cursor-pointer !border-[#D9D9D9] h-[45px] flex items-center justify-center rounded-md"
                                >
                                    <img src={Upload} alt={'Upload from Computer'} className="absolute left-4 top-[14px]" />
                                    <span className="text-[12px]">Upload from Computer</span>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <span onClick={() => setBusinessType(null)} className='text-[#757575] text-[12px] ml-8 cursor-pointer'>
                    ← Go back
                </span>
            </div>
            }
            {alertModel && <>
                <div className="modal-zz" onClick={() => setAlertModel(false)}>
                    <div className="modal-content-upload" onClick={(e) => e.stopPropagation()}>
                        <p
                            style={{
                                position: "absolute",
                                right: 5,
                                width: "12px",
                                top: "10px",
                                height: "12px",
                                cursor: "pointer",
                            }}
                            onClick={() => setAlertModel(false)}
                        >
                            X
                        </p>

                        <MyDropzone gettingfilefromdropzone={gettingfilefromdropzone} setLoader={setLoader} loader={loader} />
                    </div>
                </div>
            </>}

            {
                successModel && <>
                    <div className="modal-zz" onClick={() => setSuccessModel(false)}>
                        <div className="modal-content-zz" onClick={(e) => e.stopPropagation()}>
                            <p
                                style={{
                                    position: "absolute",
                                    right: 5,
                                    width: "12px",
                                    top: "10px",
                                    height: "12px",
                                    cursor: "pointer",
                                }}
                                onClick={() => setSuccessModel(false)}
                            >
                                X
                            </p>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                <img src={filesubnmitted} width={"200px"} height={"200px"} />

                                <h1 className="text-center">Files are Submitted!</h1>

                            </div>
                        </div>
                    </div>
                </>
            }

            <Toast
                type={toastType}
                message={toastMessage}
                subMessage={toastSubMessage}
                visible={toastVisible}
                onClose={() => setToastVisible(false)}
            />
        </div>
    )
}

export default ConfigureYourAIUpload
